module.exports = __webpack_public_path__ + "static/media/web6.8b47baca.png";